import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconIntegrations: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="integrations, frames, keyframes, interactions"><path d="M1.75 12L9 4.75L16.25 12L9 19.25L1.75 12Z" stroke="currentColor" strokeWidth="1.5"/><path d="M12 7.75L15 4.75L22.25 12L15 19.25L12 16.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconIntegrations;
